import React from "react";

import ContainerSkeleton from "src/organization/pages/project/environment/metrics/containers/Service/Service.skeleton";

const DedicationSkeleton = () =>
  [1, 2, 3].map(value => <ContainerSkeleton key={value} />);

export default DedicationSkeleton;
